export enum RtlLanguage {
  AR = 'ar', // Arabic
  FA = 'fa', // Persian (Farsi)
  HE = 'he', // Hebrew
  UR = 'ur', // Urdu
  PS = 'ps', // Pashto
  SD = 'sd' // Sindhi
}
